import { render } from "./RulesTable.vue?vue&type=template&id=5062d360"
import script from "./RulesTable.vue?vue&type=script&lang=js"
export * from "./RulesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__